module.exports = __webpack_public_path__ + "static/leatherhead-275a9366b5a9e7dce3552da92c0034d9.jpg";